<template>
    <div class="text-center">
        <v-row>
            <v-col>
                <h2>Alle Termine</h2>
                <v-row align="center">
                    <v-col cols="2">
                        <v-btn icon @click="prevWeek">
                            <v-icon v-text="'mdi-arrow-left-bold-circle-outline'"></v-icon>
                        </v-btn>
                    </v-col>
                    <v-col cols="8">
                        <span>{{ options }}</span>
                    </v-col>
                    <v-col cols="2">
                        <v-btn icon @click="nextWeek">
                            <v-icon v-text="'mdi-arrow-right-bold-circle-outline'"></v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
                <v-data-table
                    :headers="headers"
                    :items="plansWithHolidays"
                    :loading="isLoading"
                    :custom-sort="sortItems"
                    hide-default-footer
                    hide-default-header
                    class="indigo--text"
                >
                    <template v-slot:item.date="{ item }">
                        {{ formatDate(item.date) }}
                    </template>
                    <template v-slot:item.name="{ item }">
                        <v-row
                            v-if="isHoliday(item.date, item.name)"
                            class="align-center"
                        >
                            <v-col class="col-2">
                                <v-icon
                                    class="orange--text"
                                    large
                                >
                                    mdi-palm-tree
                                </v-icon>
                            </v-col>
                            <v-col>
                                <h2>{{ item.name }}</h2>
                            </v-col>
                        </v-row>
                        <v-row
                            v-else-if="isFoodDay(item.date)"
                            class="align-center"
                        >
                            <v-col class="col-2">
                                <v-icon
                                    class="cyan--text"
                                    large
                                >
                                    mdi-food-fork-drink
                                </v-icon>
                            </v-col>
                            <v-col>
                                <h2>
                                    <span v-if="item.swapped_name">
                                        <del>{{ item.name }}</del>
                                        <v-icon class="[ px-2 ]  [ cyan--text ]">
                                            mdi-swap-horizontal
                                        </v-icon>
                                        <span v-text="item.swapped_name" />
                                    </span>
                                    <span v-else>{{ item.name }}</span>
                                </h2>
                            </v-col>
                        </v-row>
                        <v-row
                            v-else
                            class="align-center"
                        >
                            <v-col class="col-2">
                                <v-icon
                                    class="[ pink--text  text--lighten-2 ]"
                                    large
                                >
                                    mdi-washing-machine
                                </v-icon>
                            </v-col>
                            <v-col>
                                <h2>
                                    <span v-if="item.swapped_name">
                                        <del>{{ item.name }}</del>
                                        <v-icon class="[ px-2 ]  [ pink--text ]">
                                            mdi-swap-horizontal
                                        </v-icon>
                                        <span v-text="item.swapped_name" />
                                    </span>
                                    <span v-else>{{ item.name }}</span>
                                </h2>
                            </v-col>
                        </v-row>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import moment from 'moment';
import PlanService from '@/services/PlanService';
import HolidayService from '@/services/HolidayService';

export default {
    name: 'UserPlan',
    data() {
        return {
            headers: [
                {
                    text: 'Datum',
                    align: 'start',
                    value: 'date',
                },
                {
                    text: 'Familie',
                    align: 'start',
                    value: 'name',
                },
            ],
            isSaving: false,
            isLoading: false,
            plans: [],
            holidays: [],
            selectedUsers: [],
            weekIndex: 0
        }
    },
    async created() {
        this.getPlans()
        this.getHolidays()
    },
    computed: {
        datesToShow() {
            const days = [];
            for (let i = 0; i <= 6; i++) {
                days.push(moment(this.weekStart).add(i, 'days').format('DD.MM.YYYY'))
            }
            return days
        },
        options() {
            return `${this.datesToShow[0]} - ${this.datesToShow[this.datesToShow.length-1]}`
        },
        week() {
            return this.weekStart.week()
        },
        weekStart() {
            return moment().add(this.weekIndex, 'weeks').startOf('week')
        },
        year() {
            return this.weekStart.year()
        },
        holidaysToShow() {
            const holidays = []
            this.holidays.forEach(holiday => {
                const start = moment(holiday.start, 'DD.MM.YYYY', 'de')
                const end = moment(holiday.end, 'DD.MM.YYYY', 'de')
                this.datesToShow.forEach(date => {
                    const momentDate = moment(date, 'DD.MM.YYYY', 'de')
                    if (momentDate.isBetween(start, end, undefined, '[]')) {
                        holidays.push({
                            date: date,
                            name: holiday.name
                        })
                    }
                })
            })
            return holidays
        },
        plansWithHolidays() {
            return this.plans.concat(this.holidaysToShow)
        }
    },
    methods: {
        async getPlans() {
            this.plans = await PlanService.getPlans(this.week, this.year, true)
        },
        async getHolidays() {
            this.holidays = await HolidayService.getHolidays()
        },
        formatDate(date) {
            date = moment(date, 'DD.MM.YYYY', 'de')
            if (date.weekday() === 5) {
                const datePlusOne = date.clone().add(1, 'days')
                return `${date.format('dd. DD.MM.')} / ${datePlusOne.format('dd. DD.MM.YYYY')}`
            } else if (date.weekday() === 6) {
                const dateMinusOne = date.clone().add(-1, 'days')
                return `${dateMinusOne.format('dd. DD.MM.')} / ${date.format('dd. DD.MM.YYYY')}`
            } else {
                return date.format('dd. DD.MM.YYYY')
            }
        },
        getHolidayName(date) {
            return this.holidaysToShow.find(holiday => holiday.date === date).name
        },
        isFoodDay(date) {
            date = moment(date, 'DD.MM.YYYY', 'de')
            return date.weekday() < 5
        },
        isHoliday(date, name) {
            return this.holidaysToShow.some(holiday => holiday.date === date && holiday.name === name)
        },
        nextWeek() {
            this.weekIndex++
            this.getPlans()
        },
        prevWeek() {
            this.weekIndex--
            this.getPlans()
        },
        sortItems(items) {
            if (!items.length) return []
            return items.sort((a, b) => {
                const dateA = moment(a.date, 'DD.MM.YYYY', 'de')
                const dateB = moment(b.date, 'DD.MM.YYYY', 'de')
                return dateA.diff(dateB)
            })
        }
    }
}
</script>
